import UtilsService from "../gRPC/Generated/UtilsService";
import RPC from "./RPC";

const utils = UtilsService.utils;
const commonmessages = UtilsService.commonmessages;

class UtilsServiceClient {
	static addBatchLogEntry(reqInfo) {
		return RPC.rpcCall(
			"/utils.UtilsService/AddBatchLogEntry",
			reqInfo,
			commonmessages.empty,
			(request) => {
				return utils.LogEntryInput.encode(request).finish();
			},
			(response) => {
				return utils.LogEntryInput.decode(response);
			},
			{},
			true
		);
	}

	static addBatchActivityEntry(reqInfo) {
		return RPC.rpcCall(
			"/utils.UtilsService/AddBatchActivityEntry",
			reqInfo,
			commonmessages.empty,
			(request) => {
				return utils.LogEntryInput.encode(request).finish();
			},
			(response) => {
				return utils.LogEntryInput.decode(response);
			},
			{},
			true
		);
	}
}

export default UtilsServiceClient;
